"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.previousStep = void 0;
var previousStep = function (setHistory) { return function (currentStep, options) { return function () {
    setHistory(function (ps) { return __spreadArrays(ps.slice(0, -1)); });
}; }; };
exports.previousStep = previousStep;
//# sourceMappingURL=previousStep.js.map